module.exports = __webpack_public_path__ + "img/start-your-buisness.6ae3099f.svg";